import { render, staticRenderFns } from "./ModattaStripePayment.vue?vue&type=template&id=3960d81e"
import script from "./ModattaStripePayment.vue?vue&type=script&lang=js"
export * from "./ModattaStripePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports